var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseEvent } from './base-event';
/**
 * The arguments for the `navigatorFilter` event.
 */
var NavigatorFilterEvent = /** @class */ (function (_super) {
    __extends(NavigatorFilterEvent, _super);
    /**
     * Constructs the event arguments from a raw object.
     */
    function NavigatorFilterEvent(e, target) {
        var _this = _super.call(this, target) || this;
        _this.from = e.from;
        _this.to = e.to;
        return _this;
    }
    return NavigatorFilterEvent;
}(BaseEvent));
export { NavigatorFilterEvent };
//# sourceMappingURL=navigator-filter-event.js.map